module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921005651_T.25f512ff.jpg";